




import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Plan, Record } from '@/domains/work';
import { isNullOrUndefined } from 'util';

interface Config {
  type: string;
  icon: string;
}

@Component
export default class RecordTemplateButton extends Vue {
  /** 记录 */
  @Prop()
  private value: Record;

  /** bus */
  @Prop()
  private bus: Vue;

  /** 参数 */
  private config: Config = {
    type: null,
    icon: null,
  };

  /** 获取记录 */
  get record(): Record { return this.value; }

  /** 设置记录 */
  set record(value: Record) { this.$emit('input', value); }

  /** 禁用 */
  get disabled() { return this.record.deleted; }

  @Watch('value', { immediate: true, deep: true })
  private onValueChange(value: Plan) {
    this.$nextTick(() => {
      switch (this.record.status) {
        case 1:
          this.config.icon = 'el-icon-edit';
          this.config.type = 'primary';
          break;
        case 2:
          this.config.icon = 'el-icon-edit';
          this.config.type = 'warning';
          break;
        case 3:
          this.config.icon = 'el-icon-check';
          this.config.type = 'success';
          break;
        case 4:
          this.config.icon = 'el-icon-back';
          this.config.type = 'danger';
          break;
        case 5:
          this.config.icon = 'el-icon-time';
          this.config.type = 'info';
          break;
      }
    });
  }
}
